/** Shown in user-facing error copy. Override with REACT_APP_SUPPORT_EMAIL in .env for production builds. */
export const DEFAULT_SUPPORT_EMAIL =
  process.env.REACT_APP_SUPPORT_EMAIL || 'accounts@ecointel.io';
